import * as React from "react";
import Grid from "@mui/material/Grid";
import moment from "moment";
import { Typography } from "@mui/material";
export const LoadingDetailTblCard = ({ data = [], onClick = () => {} }) => {
  return (
    <Grid container spacing={1} className="easy-putaway-container mt-1">
      {data.map((item, index) => (
        <Grid
          item
          xs={12}
          sm={6}
          md={6}
          key={index}
          onClick={() => {
            let items = { row: item };
            onClick(items);
          }}
        >
          <div className="easy-putaway-card">
            <Grid container spacing={0.5} columns={{ xs: 12, md: 12 }}>
              <Grid item xs={6} md={6}>
                <Typography variant="subtitle1" className="label">
                  Sr.No
                </Typography>
              </Grid>
              <Grid item xs={6} md={6}>
                <Typography variant="body1" className="value">
                  {item.G_SrNo}
                </Typography>
              </Grid>

              <Grid item xs={6} md={6}>
                <Typography variant="subtitle1" className="label">
                  BarCode
                </Typography>
              </Grid>
              <Grid item xs={6} md={6}>
                <Typography variant="body1" className="value">
                  {item?.BarCode}
                </Typography>
              </Grid>
              <Grid item xs={6} md={6}>
                <Typography variant="subtitle1" className="label">
                  Ref.No
                </Typography>
              </Grid>
              <Grid item xs={6} md={6}>
                <Typography variant="body1" className="value">
                  {item.SuppRefNo1}
                </Typography>
              </Grid>
              <Grid item xs={6} md={6}>
                <Typography variant="subtitle1" className="label">
                  Bin.Name
                </Typography>
              </Grid>
              <Grid item xs={6} md={6}>
                <Typography variant="body1" className="value">
                  {item.BinName}
                </Typography>
              </Grid>

              <Grid item xs={6} md={6}>
                <Typography variant="subtitle1" className="label">
                  Qty
                </Typography>
              </Grid>
              <Grid item xs={6} md={6}>
                <Typography variant="body1" className="value">
                  {item.G_Qty}
                </Typography>
              </Grid>

              <Grid item xs={6} md={6}>
                <Typography variant="subtitle1" className="label">
                  Unit.Code
                </Typography>
              </Grid>
              <Grid item xs={6} md={6}>
                <Typography variant="body1" className="value">
                  {item.G_Unit}
                </Typography>
              </Grid>
              <Grid item xs={6} md={6}>
                <Typography variant="subtitle1" className="label">
                  BaseQty
                </Typography>
              </Grid>
              <Grid item xs={6} md={6}>
                <Typography variant="body1" className="value">
                  {item.G_BaseQty}
                </Typography>
              </Grid>

              <Grid item xs={12} md={12}>
                <Typography variant="subtitle1" className="label">
                  {item.ItmName}
                </Typography>
              </Grid>
              {/* <Grid item xs={6} md={6}>
                <Typography variant="body1" className="value">
                  {item.ItmName}
                </Typography>
              </Grid> */}
            </Grid>
          </div>
        </Grid>
      ))}
    </Grid>
  );
};
